/** Brief 12, the sign-in screens, the onboarding wizard and the pages a client opens from a link. */
export const uzB12Auth = {
  "authPanel.title": "Birorta mijoz unutilmaydi",
  "authPanel.body": "Kapitan AI birinchi javobni beradi, siz esa kimga, qachon va nima qilishni bilib turasiz.",
  "authPanel.route.lead": "Murojaat",
  "authPanel.route.offer": "Taklif",
  "authPanel.route.payment": "To'lov",
  "authPanel.footer": "Turagentliklar uchun CRM · O'zbekiston va Markaziy Osiyo",
  "auth.lead": "Agentlik hisobingiz bilan kiring.",
  "auth.emailPlaceholder": "ism@agentlik.uz",
  "auth.passwordPlaceholder": "Kamida 8 belgi",
  "auth.notConnected": "Agentlik hali ulanmaganmi?",
  "auth.applyLink": "Ariza qoldiring",

  "onb.setup": "{name} · sozlash",
  "onb.stepOf": "{current}-qadam · {total} dan",
  "onb.back": "Orqaga",
  "onb.next": "Davom etish",
  "onb.finish": "Tayyor",
  "onb.pendingHint": "Bajarilmagan qadamlar keyinga qoldiriladi. Istalgan vaqt qaytishingiz mumkin.",
  "onb.reopen": "Qayta ochish",
  "onb.skippedList": "Keyinga qoldirilgan: {name}",
  "onb.state.pending": "Bajarilmagan",
  "onb.state.done": "Bajarildi",
  "onb.state.skipped": "Keyinroq",
  "onb.loadError": "Ma'lumotni yuklab bo'lmadi.",
  "onb.changeError": "Qadamni o'zgartirib bo'lmadi.",
  "onb.rowsError": "Ro'yxatni yuklab bo'lmadi.",
  "onb.connected": "ulangan",
  "onb.notConnected": "ulanmagan",
  "onb.stage.agency": "Agentlik",
  "onb.stage.agency.title": "Agentlik ma'lumotlari",
  "onb.stage.agency.body": "Nom, logo va aloqa ma'lumotlari ommaviy sahifalarda ko'rinadi.",
  "onb.stage.channels": "Kanallar",
  "onb.stage.channels.title": "Kanallar",
  "onb.stage.channels.body": "Mijozlar yozadigan joylarni ulang. Kapitan AI shu kanallarda birinchi javob beradi.",
  "onb.stage.providers": "Turoperatorlar",
  "onb.stage.providers.title": "Turoperatorlar",
  "onb.stage.providers.body": "Login yoki API kalitini kiriting. Narx va bron xabarlari shu yerdan keladi.",
  "onb.stage.team": "Jamoa",
  "onb.stage.team.title": "Jamoa",
  "onb.stage.team.body": "Operatorlarni taklif qiling va filialga biriktiring.",
  "onb.stage.ai": "Kapitan AI",
  "onb.stage.ai.title": "Kapitan AI",
  "onb.stage.ai.body": "Ohang va ruxsatlarni tanlang. Yangi agentlik kuzatuv rejimida boshlaydi.",

  "public.contactOperator": "Operator bilan bog'lanish",
  "public.madeWith": "Kapitan orqali yaratildi",
  "public.gone": "Havola topilmadi yoki muddati o'tgan.",

  "offer.kicker": "Shaxsiy taklif · amal qiladi {date} gacha",
  "offer.title": "Siz uchun {count} variant",
  "offer.people": "{count} kishi",
  "offer.nights": "{count} kecha",
  "offer.pricesAsOf": "narxlar {date} holatiga",
  "offer.choose": "Shu variantni tanlash",
  "offer.chosen": "Tanlandi",
  "offer.chooseFailed": "Tanlovni saqlab bo'lmadi. Qayta urinib ko'ring.",
  "offer.empty": "Bu taklifda hozircha variant yo'q.",
  "offer.gone": "Bu taklif muddati tugagan yoki mavjud emas.",
  "offer.loadFailed": "Taklifni yuklab bo'lmadi.",
  "offer.images": "Rasmlar",
  "offer.room": "Xona",
  "offer.dates": "Sana",
  "offer.priceValid": "Narx amal qiladi",
  "offer.until": "{date} gacha",
  "offer.toAirport": "Aeroportgacha {km} km",

  "sign.kicker": "Shartnoma",
  "sign.title": "Imzolash uchun shartnoma",
  "sign.signedTitle": "Imzolangan shartnoma",
  "sign.smsSign": "SMS kod bilan imzolash",
  "sign.pdfDownload": "PDF yuklab olish",

  "review.kicker": "Fikr-mulohaza",
  "review.title": "Safar qanday o'tdi?",
  "review.rating": "Baho",
  "review.comment": "Izoh (ixtiyoriy)",
  "review.submit": "Yuborish",
  "review.failed": "Yuborib bo'lmadi. Qayta urinib ko'ring.",
  "review.thanks": "Rahmat",
  "review.thanksBody": "Fikringiz qabul qilindi.",
  "review.loadFailed": "Sahifani yuklab bo'lmadi.",
} as const;
